// $(function () {
//   // getRandomStr ()
//   randomStr = new Date().getTime() + Math.random() * 1000;
//   $('.valicode_img').attr('src',`${API_ENV}verify/captcha/${randomStr}`);
// });
// $('.valicode_img').click(function(){
//   randomStr = new Date().getTime() + Math.random() * 1000;
//   $(this).attr('src',`${API_ENV}verify/captcha/${randomStr}`);

// });  
// 点击查询
$('.Query').click(function(){
  // 校验参数
  var protege = $('#protege').val();
  var guaranteeNo = $('#guaranteeNo').val();
  if(protege == '' || protege == null || guaranteeNo == '' || guaranteeNo == null){
    $('.cw').html('保单查询号和被担保人不能为空');
  		$('.cw').show();
  		window.setTimeout(function(){
  			$('.cw').hide();
  		},2000);
  }else{
    let url = API_PATHS.guarantee_query_path+`protege=${protege}&guaranteeNo=${guaranteeNo}&callback=jsonpProcess`;
    $('head').append('<script src="'+url+'" type="text/javascript"></script>');
  }
});






//////////////////
// WEBPACK FOOTER
// ./app/js/inquire.js
// module id = 29
// module chunks = 8